import React from 'react';
import PropTypes from 'prop-types';

import { useFormikContext, useField, isFunction } from 'formik';

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './DatePickerFormikField.css';

// 夾帶formik功能的date picker
export const DatePickerFormikField = ({ ...props }) => {
  const { setFieldValue } = useFormikContext();
  const [field] = useField(props);
  const className = props.isInvalid ? 'form-control is-invalid' : 'form-control';
  const { value, dateFormat, OnValueChange, ...restProps } = props;

  let dt = field.value && !isNaN(Date.parse(new Date(field.value))) ? new Date(field.value) : null;
  if (dt !== null) {
    //2021.10.25 firefox 93.0 在作怪，所有才要加上絕對值，不是吃飽撐著。
    dt = new Date(
      Math.abs(dt.getFullYear()),
      dt.getMonth(),
      dt.getDate(),
      dt.getHours(),
      dt.getMinutes(),
      dt.getSeconds()
    );
  }

  return (
    <div className="customDatePickerWidth">
      <DatePicker
        {...field}
        {...restProps}
        className={className}
        dateFormat={dateFormat}
        value={value ? new Date(value) : null}
        selected={dt}
        // selected={field.value && !isNaN(Date.parse(new Date(field.value)))? new Date(field.value) : null}
        onChange={(value) => {
          const { showTimeInput } = props;
          if (!showTimeInput) {
            if (value !== null) {
              value = new Date(value.getFullYear(), value.getMonth(), value.getDate());
            }
          }
          const fieldName = field.name;
          setFieldValue(fieldName, value, false);

          if (isFunction(OnValueChange)) {
            OnValueChange(fieldName, value);
          }
        }}
        autoComplete="off"
      />
    </div>
  );
};

DatePickerFormikField.propTypes = {
  // 是否為錯誤輸入
  isInvalid: PropTypes.bool,
  OnValueChange: PropTypes.func,
};
